export default "__VITE_ASSET__BUo42PXz__"